import instance from "@/api/axiosInstance";

export function getWebsocket(sid) {
  if (!sid) return null;

  console.log("尝试连接，sid：" + sid);

  // baseURL 在本地开发时是相对路径 /api，生产环境也可能是完整 URL。
  // 统一借助当前页面地址解析，避免生成无效的 /api/ws/... 相对 WebSocket 地址。
  const apiUrl = new URL(
    instance.defaults.baseURL || "/api",
    window.location.origin
  );
  apiUrl.protocol = apiUrl.protocol === "https:" ? "wss:" : "ws:";
  apiUrl.pathname = `${apiUrl.pathname.replace(
    /\/$/,
    ""
  )}/ws/${encodeURIComponent(sid)}`;
  apiUrl.search = "";
  apiUrl.hash = "";

  const wsUrl = apiUrl.toString();

  console.log("WebSocket连接地址:", wsUrl);

  try {
    return new WebSocket(wsUrl);
  } catch (error) {
    console.error("WebSocket连接创建失败:", error);
    return null;
  }
}
